(ns vit-configurator.db)

(def default-db
  {:preview-ready false
   :official-only true
   :logo {:type :default}
   :size :container-responsive
   :search-box-type :dialog
   :analytics :off
   :analytics-custom nil
   :vit-preview-env "live"
   :auth-required? true
   :authenticated? false
   :auth-loading? true
   :user nil
   :user-loading? true
   :config {:logo {:type :default}
            :official-only true
            :size :container-responsive}})
